var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bright container-fluid py-2"},[_c('router-view',{on:{"childrenRoute":_vm.hideNonChildren}}),(!_vm.isChildRoute)?_c('div',{staticClass:"row"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }